import {NgModule} from '@angular/core';
import {DateUtilsService} from "./date-utils.service";

@NgModule({
    providers: [DateUtilsService]
})
export class DateUtilsModule {}